import React from "react"
import { faFileLines } from "@fortawesome/free-regular-svg-icons/faFileLines"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { componentStyles, useColors } from "@mallardbay/lib-react-components"

import { CHAT_ATTACHMENT_INLINE_ICON_SIZE_PX } from "~components/shared/chat/chat-attachment-preview-constants"
import { TEST_IDS } from "~config/constants"

interface Props {
    readonly sizePx?: number
}

export default function ChatAttachmentFileIcon({
    sizePx = CHAT_ATTACHMENT_INLINE_ICON_SIZE_PX,
}: Props) {
    const styles = useStyles({ sizePx })

    return (
        <FontAwesomeIcon
            icon={faFileLines}
            style={styles.icon}
            data-testid={TEST_IDS.CHAT_ATTACHMENT_FILE_ICON}
            aria-hidden
        />
    )
}

function useStyles({ sizePx }: { sizePx: number }) {
    const colors = useColors()

    return componentStyles({
        icon: {
            color: colors.secondaryText,
            fontSize: sizePx,
            flexShrink: 0,
        },
    })
}
